import React, { useMemo } from 'react';
import { Carousel } from '@one-thd/sui-carousel';
import PropTypes from 'prop-types';
import { ListTile } from '@thd-olt-component-react/list-tile';
import classNames from 'classnames';
import NullViewTexts from '../../constants/NullViewTexts';
import NullViewContent from './ListsNullView/NullViewContent';

const ListCarousel = ({ lists, iconSize, componentId }) => {
  const isSingleList = lists.length === 1;

  const listCards = useMemo(() => {
    const { imageUrl, imageAlt } = NullViewTexts;
    const cardWidthClass = `sui-w-80 @xl:sui-w-96 @3xl:sui-w-96 ${isSingleList && '@6xl:sui-w-full'}`;

    const cards = lists?.map((list, index) => (
      <div
        key={index + list.id}
        className={classNames(cardWidthClass, {
          'sui-mr-4': index !== lists.length - 1
        })}
      >
        <ListTile
          iconSize={iconSize}
          listId={list.id}
          onDelete={() => {}}
          data={list}
          numberOfThumbnails={2}
          enableSharedIcon
          position={index}
          componentId={componentId}
          impressionName="ListsActiveState"
          impressionComponent="Lists"
        />
      </div>
    ));

    if (lists.length < 3) {
      cards.push(
        <div
          key="fallbackContent"
          className={classNames('sui-hidden', cardWidthClass, {
            '@6xl:sui-block': lists.length === 2,
            '@3xl:sui-block': lists.length === 1
          })}
        >
          <NullViewContent carousel />
        </div>
      );

      if (isSingleList) {
        cards.push(
          <div
            key="fallbackImage"
            className={classNames(
              'sui-hidden sui-overflow-hidden',
              cardWidthClass,
              '@6xl:sui-block'
            )}
          >
            <img
              className="sui-block sui-w-full sui-max-h-60 sui-h-auto sui-object-cover sui-object-center"
              src={imageUrl}
              alt={imageAlt}
              width="1400"
              height="900"
            />
          </div>
        );
      }
    }

    return cards;
  }, [lists, iconSize, componentId]);

  return (
    <div
      id="ListCarousel"
      data-testid="ListCarousel"
      className={classNames(
        'sui-h-full sui-overflow-x-hidden',
        '[&_#sui-carousel-resets]:sui-h-full',
        '[&_.swiper-wrapper]:sui-h-full',
        {
          '@6xl:[&_.swiper-slide]:sui-basis-1/3 @6xl:[&_.swiper-slide]:sui-w-1/3': isSingleList,
        }
      )}
    >
      <Carousel
        type="peek"
        layout="full-bleed"
        containerId="ListCarousel"
        slidesPerView="auto"
        slidesPerGroup={1}
        spaceBetween={0}
        breakpoints={{
          sm: { slidesPerGroup: 1, slidesPerView: 'auto' },
          md: { slidesPerGroup: 1, slidesPerView: 'auto' },
          lg: { slidesPerGroup: 1, slidesPerView: 'auto' },
          xl: { slidesPerGroup: 1, slidesPerView: 'auto' },
          '2xl': { slidesPerGroup: 1, slidesPerView: 'auto' }
        }}
        disableMargin
        className="sui-h-full"
      >
        {listCards}
      </Carousel>
    </div>
  );
};

ListCarousel.propTypes = {
  lists: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  iconSize: PropTypes.string,
  componentId: PropTypes.string
};

ListCarousel.defaultProps = {
  iconSize: 'small',
  componentId: undefined
};

export default ListCarousel;
